module.exports = __webpack_public_path__ + "img/thumbnail_GreySeal_j_normal.90fb0f76.png";